// @flow

import React from 'react';
import styled from 'styled-components';
import Input from './input';
import { SearchIcon, XIcon } from '../../icons';

import type { InputProps } from './input';

type SearchInputCleared = { currentTarget: { value: string } };
type SearchInputChange = SearchInputCleared | SyntheticEvent<HTMLInputElement>;
type SearchInputProps = {
  ...InputProps,
  onChange: SearchInputChange => void,
  value: string,
  clearable: boolean,
};

export default class SearchInput extends React.Component<SearchInputProps> {
  static defaultProps = Object.assign({}, Input.defaultProps, {
    clearable: true,
  });

  ref: ?HTMLInputElement = null;

  render() {
    const { block, width, value, clearable } = this.props;

    return (
      <Container block={block} width={width}>
        <StyledInput {...this.props} inputRef={this.storeRef} />
        <StyledSearchIcon />
        {clearable && value && value.length > 0 && (
          <StyledXIcon onClick={this.onClear} />
        )}
      </Container>
    );
  }

  storeRef = (ref: HTMLInputElement) => {
    this.ref = ref;

    if (this.props.inputRef) {
      this.props.inputRef(ref);
    }
  };

  onClear = () => {
    const { onChange } = this.props;

    if (this.ref) {
      this.ref.focus();
    }

    const event: SearchInputCleared = { currentTarget: { value: '' } };
    onChange(event);
  };
}

const Container = styled.div`
  position: relative;
  display: ${props => (props.block ? 'block' : 'inline-block')};
  width: ${props => props.width || (props.block ? '100%' : 'inherit')};
`;

const StyledInput = styled(Input)`
  &&&& {
    padding-left: 30px;
    ${props => (props.clearable ? 'padding-right: 30px;' : '')}
  }
`;

const StyledSearchIcon = styled(SearchIcon)`
  position: absolute;
  top: 7px;
  left: 7px;
`;

const StyledXIcon = styled(XIcon)`
  position: absolute;
  top: 7px;
  right: 7px;
`;
